import React, { useEffect, useRef } from "react";
import { useState } from "react";
import {
  add_blogs,
  edit_blogs,
  fetch_blog_edit_form,
  fetch_blog_create_form,
} from "../../../services/admin/blogs";
import ImageUploader from "../common/ImageUploader";
import SingleFileUploader from "../../../components/SingleFileUploader";
import { Link, Navigate, useParams } from "react-router-dom";
import TextEditor from "../TextEditor";

const BlogFormPage = () => {
  const { id } = useParams();

  const [shouldRedirectToIndex, setShouldRedirectToIndex] = useState(false);

  const [formData, setFormData] = useState({
    title: "",
    body: "",
    image: "",
  });

  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    let formDepCallback = () => {
      return fetch_blog_create_form();
    };
    if (id !== undefined) {
      formDepCallback = () => {
        return fetch_blog_edit_form(id);
      };
    }

    formDepCallback().then((res) => {
      if (res.status === "ok") {
        if (res.data) {
          setFormData(res.data);
        }
      }
    });
  }, []);

  const handleTextInputChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    if (validationErrors[name]) {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }
  };

  const handleFileInputChange = (fieldValue) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      image: fieldValue,
    }));
  };

  const handleSave = () => {
    console.log(formData);
    setValidationErrors({});
    if (id !== undefined) {
      edit_blogs(id, formData).then((res) => {
        if (res.status === "ok") {
          setShouldRedirectToIndex(true);
        } else if (res.type === "validation") {
          setValidationErrors(res.validations);
        }
      });
    } else {
      add_blogs(formData).then((res) => {
        if (res.status === "ok") {
          setShouldRedirectToIndex(true);
        } else if (res.type === "validation") {
          setValidationErrors(res.validations);
        }
      });
    }
  };

  if (shouldRedirectToIndex) {
    return <Navigate to={"/admin/blogs/list"} />;
  }

  return (
    <div className="page-content py-3 px-4 flex-grow-1 flex-shrink-1 bg-lightgray">
      <div className="mb-4">
        <span className="fw-bold dashboard-title">
          {id !== undefined ? "Edit Blog" : "Add Blog"}
        </span>
        <div className="breadcrumbs path fw-semibold gap-2 d-flex flex-row">
          <Link className={"link"} to={"/admin/"}>
            Dashboard
          </Link>
          <span>&gt;</span>
          <Link className={"link"} to={"/admin/blogs/list"}>
            Blogs
          </Link>
          <span>&gt;</span>
          <span>{id !== undefined ? formData.title : "New Blog"}</span>
        </div>
      </div>

      <div className="inputs-container bg-white">
        {Object.keys(validationErrors).length > 0 && (
          <div className="alert alert-danger">
            Please address the errors highlighted below.
          </div>
        )}
        <div className="product-info d-flex flex-column gap-4">
          <div className="d-flex flex-md-row flex-column">
            <div className="d-flex flex-column gap-1 input-container mb-md-0 mb-3">
              <label className="fw-semibold">Blog Cover Image</label>
              {/* <ImageUploader
                onFileInputChange={handleFileInputChange}
              /> */}
              <SingleFileUploader
                options={{
                  name: "image",
                  currentPhoto: formData.image,
                  onPhotoChange: handleFileInputChange,
                  type: "file",
                }}
                type="image"
              />
            </div>
          </div>

          <div className="d-flex flex-md-row flex-column">
            <div className="d-flex flex-column gap-1 input-container mb-md-0 mb-3">
              <label className="fw-semibold">Blog Title</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleTextInputChange}
                placeholder={"Blog Title"}
              />
              {validationErrors.title && (
                <span className="error-text text-danger">
                  {validationErrors.title[0]}
                </span>
              )}
            </div>
          </div>

          <div className="row pr-5">
            <div className="col-12 mb-5">
              <label className="fw-semibold">Blog Body</label>
              <TextEditor
                value={formData.body}
                onChange={(content) => {
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    body: content,
                  }));
                }}
                placeholder="Relevant Blog Notes"
                height={500}
              />
              {validationErrors.body && (
                <span className="error-text text-danger">
                  {validationErrors.body[0]}
                </span>
              )}
            </div>
          </div>
        </div>

        {Object.keys(validationErrors).length > 0 && (
          <div className="alert alert-danger mt-3">
            Please address the errors highlighted.
          </div>
        )}

        <div className="d-flex flex-md-row flex-column justify-content-md-end align-items-center gap-3 btn-containers">
          <button className={"btn btn-primary p-10-50"} onClick={handleSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlogFormPage;
